import { useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Suspense } from "react";
import moment from "moment/min/moment-with-locales";
import LoadingIndicator from "../LoadingIndicator";
import { Await, useLoaderData } from "react-router-dom";

export default function LatestDataRow({ radio, dataType }) {
    const [loading, setLoading] = useState(false);
    const { latestCalculatedData } = useLoaderData();

    const formatDate = date => (date ? moment(date).format("L").slice(0, -5) : "-");
    const renderDateColumn = moduleInfo => formatDate(moduleInfo?.latest_datetime);

    return (
        <Row className="py-1 border-bottom align-items-center fs-8-xs">
            <Col xs={4} className="align-content-center">
                {radio.radio_name}
            </Col>
            <Suspense
                fallback={
                    <>
                        {[0].map(i => (
                            <Col key={i}>
                                <LoadingIndicator width={20} showText={false} />
                            </Col>
                        ))}
                    </>
                }>
                <Await resolve={latestCalculatedData}>
                    {resolvedData => (
                        <>
                            {[dataType === 1 ? 3 : 9].map(id => (
                                <Col key={id} className=" align-content-center text-center">
                                    {renderDateColumn(
                                        resolvedData.data.find(x => x.module_id === id && x.radio_id === radio.radio_id && x.data_type === dataType)
                                    )}
                                </Col>
                            ))}
                        </>
                    )}
                </Await>
            </Suspense>
        </Row>
    );
}
